



































































































































































































































































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import IFire from '@/components/icons/IFire.vue'
import IArrow from '@/components/icons/IArrow.vue'
import ICheck from '@/components/icons/ICheckContactBlock.vue'
import IClose from '@/components/icons/IClose.vue'
import IEdit from '@/components/icons/IEdit.vue'
import IPencil from '@/components/icons/IPencil.vue'
import BtnDefault from '@/components/UI/BtnDefault.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import Modal from '@/components/UI/Modal.vue';
import {cloneDeep} from "lodash"

const newshards = namespace('newshards')
const locale = namespace('locale')
const resources = namespace('resources')

@Component({
  components: {
    'i-fire': IFire,
    'i-arrow': IArrow,
    'i-check': ICheck,
    'i-close': IClose,
    'i-edit': IEdit,
    'i-pencil': IPencil,
    BtnDefault,
    Tooltip,
    Modal,
  }
})

export default class ContactsShard extends Vue {
  @newshards.Action('saveShardFromServer') protected saveShardFromServer:any
  @newshards.Action('editContactFromServer') protected editContactFromServer:any
  @newshards.Action('editLocationFromServer') protected editLocationFromServer:any
  @newshards.Action('addContactFromServer') protected addContactFromServer:any
  @newshards.Action('addLocationFromServer') protected addLocationFromServer:any
  @newshards.Action('loadContactsFromServer') protected loadContactsFromServer:any
  @newshards.State('contactsStore') protected contactsStore:any
  @locale.Getter('getLocale') protected locale: any
  @resources.Getter('getCountries') protected getCountries: any
  @resources.Action('getCountryFromServer') protected getCountryFromServer: any

  @Prop({type: [Object], default: {}}) protected shard!: any
  @Prop({type: [Boolean], default: false}) protected loadShardStatus!: boolean
  @Prop({type: Boolean, default: false}) protected disabledShard!: boolean

  currentType:any = {}
  value:string = ""
  isEditType:boolean = false
  typeTitle:any = this.$t('newShardList.contacts.custom')
  currentValue:string = ""
  currentTitle:string = ""
  multipleTypes:any = ["custom", "email", "phone", "site", "location"]
  openModal:boolean = false
  contactLength:number = 35
  location:any = {
    country: '',
    region: '',
    city: '',
    address: '',
    postCode: '',
  }
  currentLocation:any = {}
  loading:boolean = false
  loadingAttr:boolean = false
  currentContact:any = {}

  @Watch('locale')
  changeContacts() {
    this.loadContactsFromServer()
    this.getCountryFromServer()
  }
  
  get countries() {
    return this.getCountries
  }

  get currentContactsStore() {

    let contactsStore = this.contactsStore
    
    let hardcodeStore = [{type: 'email', title: 'Email'}, {type: "phone", title: "Телефон"}, {
      type: "site",
      title: "Сайт"
    }, {type: "custom", title: "Другое"}, {type: "location", title: this.$t('newShardList.contacts.location.title')},]

    let exceptTypes = ["firstName", "secondName"]

    contactsStore = [...contactsStore, ...hardcodeStore]

    contactsStore = contactsStore.filter((elem:any, index:any, self:any) => self.findIndex(
      (t:any) => {
        return (t.type === elem.type && !exceptTypes.includes(t.type))
      }) === index)

      return contactsStore
  }

  get filteredContacts() {

    let contactsStore = this.currentContactsStore
    this.shard.contactBlock.contacts.forEach((contact:any) => {
      return contactsStore = contactsStore.filter((contactStore:any) => (contactStore.type !== contact.type || this.multipleTypes.includes(contactStore.type)) && contactStore.type != 'custom' )
    })
    return contactsStore
  }

  get sortedContacts() {
    this.filteredContacts.sort((a:any, b:any) => {
        return a.title.localeCompare(b.title);
    });
    let custom = this.contactsStore.filter((contact:any) => contact.type == 'custom')
    return [...this.filteredContacts, ...custom]
  }

  get sortedContactsbyOrder() {
    this.shard.contactBlock.contacts = this.shard.contactBlock.contacts.filter((contact:any) => contact.value.length != 0)
    return this.shard.contactBlock.contacts.sort((a:any, b:any) => {
      return a.order - b.order
    })
  }

  get validBtn() {
    return this.currentType.type == 'location' ? !(this.location.country.length || this.location.region.length || this.location.city.length || this.location.address.length || this.location.postCode.length) : !(this.value && this.currentType.type)
  }

  get locations() {
    this.shard.contactBlock.locations.forEach((location: any) => {
      let locationValue = ''
      let currentCountry = this.getCountries.filter((country:any) => country.value == location.countryCode)
      if(currentCountry.length != 0) locationValue = currentCountry[0].title + ', '
      if(location.region) locationValue += location.region + ', '
      if(location.city) locationValue += location.city + ', '
      if(location.address) locationValue += location.address + ', '
      if(location.postCode) locationValue += location.postCode + ', '
      location.value = locationValue.slice(0, -2)
    });
    return this.shard.contactBlock.locations
  }

  created() {
    window.addEventListener('resize', this.updateContactLength);
    this.getCountryFromServer()
  }

  @Watch('currentType')
  checkCustom() {
    if(this.currentType.type == 'custom') {
      this.isEditType = true
    }
  }

  getTitle(title:string) {
    let str = ''
    if(title.length > 0) {
      str = title[0].toUpperCase() + title.slice(1)
    }
    return str
  }

  blurSelect() {
    this.$emit('changeStopScroll', false)
  }

  async addContact() {
    this.loading = true
    if(this.currentType.type == 'location') {
      let params = {
        shard_id: this.shard.id,
        params: {
          postCode: this.location.postCode,
          countryCode: this.location.country,
          region: this.location.region,
          city: this.location.city,
          address: this.location.address,
          title: this.$t('newShardList.contacts.location.title')
        }
      }
      await this.addLocationFromServer(params)
      this.location = {
        country: '',
        region: '',
        city: '',
        address: '',
        postCode: '',
      }
      this.currentType = {}
      this.value = ""
    } else {
      let title = this.currentType.type == 'custom' ? this.typeTitle : this.currentType.title
      if(this.shard.contactBlock.contacts.find((contact:any) => contact.title == title && !this.multipleTypes.includes(contact.type))) {
        this.openModal = true
      } else {
        let params = {
          shard_id: this.shard.id,
          params: {
            type: this.currentType.type,
            title: title,
            value: this.value
          }
        }

        await this.addContactFromServer(params)
        await this.saveTitle(this.currentType.type, this.value)

        this.value = ""
        this.currentType = {}
        this.typeTitle = this.$t('newShardList.contacts.custom')
        this.location = {
          country: '',
          region: '',
          city: '',
          address: '',
          postCode: '',
        }
      }
    }
    this.loading = false
  }

  changeType(contact: any, item: any) {
    if(item.type == 'custom') {
      contact.editType = true
      contact.type = 'custom'
    }
  }

  async changeIsNew(prop:any) {
    if(this.shard.attrs.isNew !== prop) {
      this.loadingAttr = true
      await this.saveShardFromServer({
        id: this.shard.id,
        params: {
          attrs: {
            isNew: prop,
            hotLevel: this.shard.attrs.hotLevel
          }
        }
      })
      this.loadingAttr = false
    }
  }

  async changeHot(n:number) {
    if(this.shard.attrs.hotLevel != n) {
      this.loadingAttr = true
      await this.saveShardFromServer({
        id: this.shard.id,
        params: {
          attrs: {
            hotLevel: n,
            isNew: this.shard.attrs.isNew
          }
        }
      })
      this.loadingAttr = false
    }
  }

  editValue(contact: any) {
    let flag = false
    this.shard.contactBlock.contacts.forEach((contact:any) => {
      if(contact.edit) flag = true
    })
    this.shard.contactBlock.locations.forEach((location:any) => {
      if(location.edit) flag = true
    })
    if(!flag) {
      if(contact.type == 'location') {
        this.currentLocation = cloneDeep(contact)
        contact.edit = true
      } else {
        this.currentContact = cloneDeep(contact)
        contact.edit = true
        this.currentValue = contact.value
        
      }
    }
  }

  editType(contact:any) {
    this.shard.contactBlock.contacts.forEach((contact:any) => {
      contact.editType = false
      if(contact.edit) {
        this.saveContact(contact)
      }
    })
    contact.editType = true
    this.currentTitle = contact.title
  }

  editContact(contact:any) {
    let payload = {
      id: contact.id,
      params: {
        title: contact.title,
        value: contact.value
      }
    }
    this.editContactFromServer(payload)
  }

  resetValue(contact:any) {
    if(contact.type == 'location') {
      contact = this.currentLocation
      this.shard.contactBlock.locations.map((location: any) => location.edit = false)
    } else {
      contact.value = this.currentValue
      this.currentValue = ""
    }
    contact.edit = false
  }
  resetType(contact:any) {
    contact.title = this.currentTitle
    this.currentTitle = ""
    contact.editType = false
  }
  resetCurrentType(){
    this.currentType = {}
    this.$emit('changeStopScroll', true)
  }

  async saveContact(contact: any) {
    this.loading = true
    if(contact.type == 'location') {
      let payload = {
        id: contact.id,
        params: this.currentLocation
      }
      await this.editLocationFromServer(payload)
    } else {
      let payload = {
        id: contact.id,
        params: {
          title: contact.title,
          value: contact.value
        }
      }
      await this.editContactFromServer(payload)
    }
    this.saveTitle(contact.type, contact.value)
    this.loading = false
  }

  saveTitle(type: string, value: string) {
    let params
    if(this.shard.type == 'person') {
      if(type == 'firstName' || type == 'secondName') {
        let firstNameArr = this.shard.contactBlock.contacts.filter((contact:any) => contact.type == 'firstName')
        let firstName = type == 'firstName' ? value :
                                firstNameArr.length > 0 ? firstNameArr[0].value : ''
        let secondNameArr = this.shard.contactBlock.contacts.filter((contact:any) => contact.type == 'secondName')
        let secondName = type == 'secondName' ? value :
                                secondNameArr.length > 0 ? secondNameArr[0].value : ''
        params = {
          title: `${firstName} ${secondName}`,
          attrs: {
            isNew: this.shard.attrs.isNew,
            hotLevel: this.shard.attrs.hotLevel
          }
        }
      } else if(type == 'companyTitle' || type == 'position') {
        let companyTitleArr = this.shard.contactBlock.contacts.filter((contact:any) => contact.type == 'companyTitle')
        let companyTitle = type == 'companyTitle' ? value :
                                    companyTitleArr.length > 0 ? companyTitleArr[0].value : ''
        let positionArr = this.shard.contactBlock.contacts.filter((contact:any) => contact.type == 'position')
        let position = type == 'position' ? value :
                                positionArr.length > 0 ? positionArr[0].value : ''
        params = {
          subtitle: `${companyTitle} ${position}`,
          attrs: {
            isNew: this.shard.attrs.isNew,
            hotLevel: this.shard.attrs.hotLevel
          }
        }
      }
    } else if(this.shard.type == 'company') {
      if(type == 'companyTitle') {
        params = {
          title: value,
          attrs: {
            isNew: this.shard.attrs.isNew,
            hotLevel: this.shard.attrs.hotLevel
          }
        }
      } else if(type == 'standTitle') {
        params = {
          subtitle: value,
          attrs: {
            isNew: this.shard.attrs.isNew,
            hotLevel: this.shard.attrs.hotLevel
          }
        }
      }
    } else if(this.shard.type == 'product') {
      if(type == 'productTitle') {
        params = {
          title: value,
          attrs: {
            isNew: this.shard.attrs.isNew,
            hotLevel: this.shard.attrs.hotLevel
          }
        }
      } else if(type == 'vendorCode' || type == 'companyTitle') {
        let vendorCodeArr = this.shard.contactBlock.contacts.filter((contact:any) => contact.type == 'vendorCode')
        let vendorCode = type == 'vendorCode' ? value : 
                                  vendorCodeArr.length > 0 ? vendorCodeArr[0].value : ''
        let companyTitleArr = this.shard.contactBlock.contacts.filter((contact:any) => contact.type == 'companyTitle')
        let companyTitle = type == 'companyTitle' ? value : 
                                    companyTitleArr.length > 0 ? companyTitleArr[0].value : ''
        params = {
          subtitle: `${vendorCode} ${companyTitle}`,
          attrs: {
            isNew: this.shard.attrs.isNew,
            hotLevel: this.shard.attrs.hotLevel
          }
        }
      }
    }
    this.saveShardFromServer({
      id: this.shard.id,
      params: params
    })
  }

  saveNewType() {
    this.isEditType = false
  }

  saveType(contact: any) {
    contact.editType = false
    this.editContact(contact)
  }

  updateContactLength() {
    let width = window.innerWidth
    this.contactLength = width > 1820 ? 35 :
           width > 1720 ? 20 :
           width > 1620 ? 17 :
           width > 1520 ? 14 :
           width > 1420 ? 12 :
           width > 1320 ? 9 :
           width > 1220 ? 6 :
           width > 1120 ? 4 : 0
  }

}
